module.exports = __webpack_public_path__ + "static/media/learn-to-play-live.84f20149.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/CubeGrid/assets/learn-to-play-live.png
// module id = 473
// module chunks = 0